// extracted by mini-css-extract-plugin
module.exports = {"list-item":"Zzafb"};